// extracted by mini-css-extract-plugin
module.exports = {"pdf-activity":"PDFActivity_pdf-activity__N3Nmq"};